import React from 'react';
import { IconArrowRightBold } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

export interface ZigzinBannerProps {
  onClick: () => void;
}

export const ZigzinBanner: React.FC<React.PropsWithChildren<ZigzinBannerProps>> = ({ onClick }) => {
  return (
    <Wrapper className={Typography.BODY_14_SEMIBOLD} onClick={onClick}>
      <Image src='https://cf.image-farm.s.zigzag.kr/original/mkt/2025/10/23/202510231220140396_79978.png' alt='직진' />
      <Text>지금 주문하면 내일 도착</Text>
      <TouchArea>
        <span className={Typography.BODY_13_SEMIBOLD}>전체보기</span>
        <IconArrowRightBold width={16} height={16} color='textSecondary' style={{ margin: '0 0 0 2px' }} />
      </TouchArea>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 0 16px;
  display: flex;
  align-items: center;
  height: 44px;
  line-height: 17px;
  border-radius: 8px;
  background-color: ${vars.v3Color.staticWhite};

  & > svg {
    margin: 0 6px 0 0;
    flex-shrink: 0;
  }
`;

const Text = styled.div`
  flex-grow: 1;
  font-size: 14px;
  font-weight: 600;
  color: ${vars.color.textPrimary};
`;

const TouchArea = styled.div`
  position: relative;
  right: -5px;
  display: flex;
  align-items: center;
  color: ${vars.color.textSecondary};
  padding: 0 0 0 4px;
  height: 50px;
  flex-shrink: 0;
`;

const Image = styled.img`
  margin-right: 6px;
  position: relative;
  top: 0.5px;
  width: 44px;
  height: 16px;
`;
